// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28855":"fab2cefb","35187":"fab2cefb","38487":"fab3fefb","47984":"fabefbfb","57287":"fab277c3","60107":"fab1defb","68833":"fab2cefb","70889":"fab3fefb","75361":"fabefbfb","75439":"fab2cefb","81426":"fab0409e","95113":"fab2cefb","95561":"fab73efb"}[chunkId] + ".chunk.css";
};